import SearchIcon from "components/icons/SearchIcon";
import React, {useMemo, useState} from "react";
import {
    MdChevronRight,
    MdChevronLeft,
    MdCircle,
    MdCircleNotifications,
    MdConfirmationNumber,
    MdEdit, MdOutlineSave, MdOutlineCancel, MdFileDownload, MdPerson, MdDownload, MdPeople
} from "react-icons/md";
import {
    useGlobalFilter,
    usePagination,
    useSortBy,
    useTable,
} from "react-table";
import {DiAndroid, DiApple} from "react-icons/di";
import {utils, writeFile} from "xlsx";
import {NumberInput} from "@chakra-ui/react";
import avatar from "assets/img/profile/Subtractprofile white.png";
import axios from "axios";
import {useUserAuth} from "../../../../context/UserAuthContext";
import {AES, enc} from "crypto-js";

function UsersOverView(props) {
    const {columnsData, tableData} = props;

    const columns = useMemo(() => columnsData, [columnsData]);
    const data = useMemo(() => tableData, [tableData]);

    const tableInstance = useTable(
        {
            columns,
            data,
        },
        useGlobalFilter,
        useSortBy,
        usePagination
    );

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page,

        prepareRow,
        nextPage,
        previousPage,
        setPageSize,

        setGlobalFilter,
        state,
    } = tableInstance;

    const {pageSize} = state;
    const currentPage = state.pageIndex; // Page index starts from 0
    const totalPages = Math.ceil(data.length / pageSize);

    let [userEditable, setUserEditable] = useState(false);
    let [acl, setAcl] = useState("")

    const CROMPTON_URL = process.env.REACT_APP_CROMPTON_SENZE_URL;
    const CROMPTON_ANALYTICS_URL = process.env.REACT_APP_CROMPTON_SENZE_ANALYTICS_URL;

    //const CROMPTON_URL = "https://iot.crompton.co.in:8443/PAPI/"
    const secretKey = "cromptonssecretkey";
    let [selectedValue, setSelectedValue] = useState("100")
    let {Token, logOut, Username, accesscontrollevel} = useUserAuth();
    const decryptedValueuname = AES.decrypt(Username, secretKey).toString(enc.Utf8);
    const decryptedValue = AES.decrypt(Token, secretKey).toString(enc.Utf8);

    const renderDeviceTypeIcons = (idfaValues) => {
        const hasAndroid = idfaValues.some((idfa) => idfa.toLowerCase() === idfa);
        const hasIOS = idfaValues.some((idfa) => idfa.toUpperCase() === idfa);

        return (
            <tr>
                <td></td>
                {/* Empty cell for alignment */}
                <td></td>
                {/* Empty cell for alignment */}
                <td></td>
                {/* Empty cell for alignment */}
                <td style={{display: 'flex', alignItems: 'center'}}>
                    {hasAndroid && <div
                        className="text-[22px] text-gray-600 dark:text-white"
                    >
                        <DiAndroid/>
                    </div>}
                    {hasIOS && <div
                        className="text-[22px] text-gray-600 dark:text-white"
                    >
                        <DiApple/>
                    </div>}
                </td>
            </tr>
        );
    };

    function convertGMTtoIST(gmtDateTime) {
        // Create a new Date object with the GMT date and time
        const gmtDate = new Date(gmtDateTime);

        // Get the time zone offset for IST
        const istOffset = gmtDate.getTimezoneOffset() + 330; // IST is UTC+5:30

        // Create a new Date object with the IST date and time
        const istDate = new Date(gmtDate.getTime() + istOffset);

        // Return the IST date and time in DD/MM/YYYY HH:MM format
        return istDate.toLocaleString('en-IN', {timeZone: 'Asia/Kolkata'});
    }

    function getCurrentDate() {
        const today = new Date();
        const day = String(today.getDate()).padStart(2, '0');
        const month = String(today.getMonth() + 1).padStart(2, '0'); // Jan is 0!
        const year = today.getFullYear();

        return `${day}-${month}-${year}`
    }

    function getUserType(userLevel) {
        switch (userLevel) {
            case 0:
                return "MEMBER"
            case 1:
                return "ADMIN"
            case 2:
                return "FW DEV"
            case 3:
                return "MARKETING"
            case 4:
                return "APP DEV"
            case 5:
                return "ANALYTICS USER"
        }
    }

    function exportUserData() {
        let filteredData

        filteredData = data.map((item) => ({
            MobileNumber: item.mobileNumber,
            Email: item.email,
            Name: item.name,
            IDFA: item.idfa.join(", "),
            AccessLevel: item.aclString,
            CreatedTime: convertGMTtoIST(item.createdTime)
        }));

        let wb = utils.book_new(),
            ws = utils.json_to_sheet(filteredData);
        utils.book_append_sheet(wb, ws, "crompton_user_details")
        writeFile(wb, "crompton_user_details" + getCurrentDate() + ".xlsx")
    }

    const [count, setCount] = useState(0);

    function editUserAccess(rowData) {
        //console.log(rowData)
        const {mobileNumber, email, ...otherData} = rowData;
        if (rowData.email !== null || rowData.email === "") {
            setGlobalFilter(rowData.email)
        } else {
            setGlobalFilter(rowData.mobileNumber)
        }
        setUserEditable(true)
    }

    function modifyUserAccessLevelApi(emailPhone, acl) {
        var bodyFormData;
        //console.log("ACL:", acl)
        if (acl === "") {
            setGlobalFilter("")
            setUserEditable(false)
        } else {
            if (!emailPhone.includes("@")) {
                bodyFormData = {
                    mobile: emailPhone,
                    acl: acl
                }
            } else {
                bodyFormData = {
                    email: emailPhone,
                    acl: acl
                }
            }
            //console.log(bodyFormData)
            return axios({
                method: 'put',
                url: CROMPTON_URL + 'user/updateAcl',
                data: bodyFormData,
                headers: {
                    Authorization: decryptedValue,
                }
            }).then(response => {
                //console.log(response)
                window.location.reload()

            })
                .catch(
                    error => {
                        //console.log(error)
                    }
                )
        }

    }

    function saveUserAccess(rowData) {
        //console.log(rowData)
        const {mobileNumber, email, ...otherData} = rowData;
        //setGlobalFilter("")
        setUserEditable(false)
        if (rowData.email !== null) {
            //console.log(rowData.email)
            modifyUserAccessLevelApi(rowData.email, acl)
        } else {
            //console.log(rowData.mobileNumber)
            modifyUserAccessLevelApi(rowData.mobileNumber, acl)
        }

    }

    function editingCancel() {
        //console.log(rowData)
        setGlobalFilter("")
        setUserEditable(false)
    }

    function handleUserAccessLevelDropdown() {
        const userLevelSelectBox = document.getElementById("userLevelSelectBox")
        acl = userLevelSelectBox.options[userLevelSelectBox.selectedIndex].value
        setAcl(userLevelSelectBox.options[userLevelSelectBox.selectedIndex].value)
        //console.log(acl)
    }

    function handleChangeUserAclFilter() {
        const selectBox = document.getElementById("selectBox")
        selectedValue = selectBox.options[selectBox.selectedIndex].value
        setSelectedValue(selectBox.options[selectBox.selectedIndex].value)
        //console.log(selectedValue)
        setGlobalFilter(selectedValue)
        //getRegisteredUsersTrend(selectedValue)
    }


    return (
        <div className="h-full w-full">

            {/* Search */}
            <div className="mx-auto mt-5 flex w-full gap-1 overflow-hidden md:!gap-6 xl:w-[96%]">
                <div
                    className="flex h-[45px] w-full rounded-xl border !border-gray-200 dark:!border-none dark:!bg-navy-700 md:w-[870px] xl:w-full"
                    onChange={(e) => setGlobalFilter(e.target.value)}>
                    <SearchIcon className="dark:text-white"/>
                    <input
                        placeholder="Search..."
                        className="!w-full rounded-xl text-sm font-medium outline-none dark:bg-navy-700 dark:text-white sm:w-[50px] xl:!w-full"
                        type="text"
                    />
                </div>
                <div
                    className="w-full rounded-xl border !border-gray-200 px-3 text-sm font-medium text-gray-600 outline-none dark:!border-none dark:bg-navy-700 md:w-fit">
                    <select
                        className="h-[45px] w-full rounded-xl text-sm font-medium text-gray-600 outline-none dark:bg-navy-700 md:w-fit md:pr-8 xl:pr-20"
                        name=""
                        id="selectBox" onChange={handleChangeUserAclFilter}>
                        <option value="">All</option>
                        <option value="ADMIN">ADMIN</option>
                        <option value="MEMBER">MEMBER</option>
                        <option value="FW DEV">FW DEV</option>
                        <option value="APP DEV">APP DEV</option>
                        <option value="MARKETING">MARKETING</option>
                    </select>
                </div>
                <button className="flex items-center justify-center rounded-xl border
                !border-gray-200 p-3 text-navy-700 transition duration-200 hover:cursor-pointer
                hover:bg-gray-100 active:bg-gray-50 dark:!border-none dark:bg-navy-700 dark:text-white
                dark:hover:bg-white/20 dark:active:bg-white/10" onClick={exportUserData}>
                    <MdDownload/>
                   Export
                </button>

            </div>
            {/*<div className="relative flex items-center justify-between">
                <div
                    onChange={(e) => setGlobalFilter(e.target.value)}
                    className="flex w-[400px] max-w-full items-center rounded-xl p-[8px] pt-[20px] xl:ml-3">
                    <div
                        className="flex h-[38px] w-[400px] mr-5 flex-grow items-center rounded-xl bg-lightPrimary text-sm text-gray-600 dark:!bg-navy-900 dark:text-white">
                        <SearchIcon/>
                        <input
                            type="text"
                            placeholder="Search...."
                            className="block w-full rounded-full bg-lightPrimary text-base text-navy-700 outline-none dark:!bg-navy-900 dark:text-white"
                        />
                    </div>

                    <div className="w-full rounded-xl border !border-gray-200 px-3 text-sm font-medium text-gray-600 outline-none dark:!border-none dark:bg-navy-700 sm:w-full md:w-fit">
                        <select id ="selectBox" onChange={handleChangeUserAclFilter}
                                className="mb-3 flex items-center justify-center text-sm font-bold text-gray-600 me-2 hover:cursor-pointer dark:!bg-navy-800 dark:text-white">
                            <option value="">All</option>
                            <option value="ADMIN">ADMIN</option>
                            <option value="MEMBER">MEMBER</option>
                            <option value="FW DEV">FW DEV</option>
                            <option value="APP DEV">APP DEV</option>
                            <option value="MARKETING">MARKETING</option>
                        </select>
                    </div>
                </div>
                <button
                    className=" mb-3 flex items-center justify-center text-sm font-bold text-gray-600 me-2 hover:cursor-pointer dark:!bg-navy-800 dark:text-white"
                    onClick={exportUserData}
                >
                    Export Data
                </button>
            </div>*/}

            {/* table */}
            <div className="mt-[14px] h-full w-full overflow-x-scroll 2xl:overflow-x-hidden">
                <table {...getTableProps()} className="mt-8 h-max w-full" variant="simple" color="gray-500" mb="24px">
                    <thead className="w-full">
                    {headerGroups.map((headerGroup, index) => (
                        <tr
                            className="items-center border-b border-gray-200 dark:!border-white/10"
                            {...headerGroup.getHeaderGroupProps()}
                            key={index}
                        >
                           {/* {...column.getHeaderProps(column.getSortByToggleProps())}*/}
                            {headerGroup.headers.map((column, index) => (
                                <th

                                    className="border-b border-gray-200 pr-20 pb-[10px] text-start dark:!border-navy-700"
                                    key={index}
                                >
                                    <div className="text-xs font-bold tracking-wide text-gray-600">
                                        {column.render("Header")}
                                    </div>
                                </th>
                            ))}
                        </tr>
                    ))}
                    </thead>
                    <tbody {...getTableBodyProps()}>
                    {page.map((row, indexPage) => {
                        prepareRow(row);
                        return (
                            <tr
                                className="border-b border-gray-200 dark:!border-white/10"
                                {...row.getRowProps()}
                                key={indexPage}
                            >
                                {row.cells.map((cell, index) => {
                                    let data = "";
                                    if (cell.column.Header === "USER NAME") {
                                        data = (
                                            <div className="flex items-center gap-2">
                                                <div
                                                    className={`flex h-[56px] w-14 items-center justify-center rounded-full text-[50px] text-[#004c86] dark:!bg-navy-700 dark:text-white bg-lightPrimary `}>
                                                    <MdPerson/>
                                                </div>
                                                <p className="text-sm font-bold text-navy-700 dark:text-white">
                                                    {cell.value}
                                                </p>
                                            </div>
                                        );
                                    } else if (cell.column.Header === "EMAIL") {
                                        data = (
                                            <div className="flex items-center gap-2">
                                                <p className="text-sm font-bold text-navy-700 dark:text-white">
                                                    {cell.value}
                                                </p>
                                            </div>
                                        );
                                    } else if (cell.column.Header === "MOBILE NUMBER") {
                                        data = (
                                            <div className="flex items-center gap-2">
                                                <p className="text-sm font-bold text-navy-700 dark:text-white">
                                                    {cell.value}
                                                </p>
                                            </div>
                                        );
                                    } else if (cell.column.Header === "JOIN DATE") {
                                        data = (
                                            <div className="flex items-center gap-2">
                                                <p className="text-sm font-bold text-navy-700 dark:text-white">
                                                    {convertGMTtoIST(cell.value)}
                                                </p>
                                            </div>
                                        );
                                    } else if (cell.column.Header === "PLATFORM") {
                                        data = (
                                            <div className="flex items-center gap-2">
                                                <p className="text-sm font-bold text-navy-700 dark:text-white">
                                                    {renderDeviceTypeIcons(cell.value)}
                                                </p>
                                            </div>
                                        );
                                    } else if (cell.column.Header === "SR") {
                                        data = (
                                            <div
                                                className="flex items-center gap-2"
                                            >
                                                <p className="text-sm font-bold text-navy-700 dark:text-white">
                                                    {(currentPage * pageSize) + (indexPage + 1)}
                                                </p>
                                            </div>
                                        );
                                    } else if (cell.column.Header === "USER TYPE") {
                                        data = (
                                            !userEditable ?
                                                <div className="flex items-center gap-2">
                                                    <p className="text-sm font-bold text-navy-700 dark:text-white">
                                                        {cell.value}
                                                    </p>
                                                </div> :

                                                <select id="userLevelSelectBox"
                                                        className="mb-3 flex items-center justify-center text-sm font-bold text-gray-600 me-2
                                                            hover:cursor-pointer dark:!bg-navy-800 dark:text-white"
                                                        onChange={handleUserAccessLevelDropdown}>
                                                    <option value="1" key="1">ADMIN</option>
                                                    <option value="2" key="2">FW DEV</option>
                                                    <option value="3" key="3">MARKETING</option>
                                                    <option value="4" key="4">APP DEV</option>
                                                    <option value="5" key="5">ANALYTICS USER</option>
                                                    <option value="0" key="0">MEMBER</option>
                                                </select>
                                        );

                                    } else if (cell.column.Header === "ACTIONS") {
                                        {
                                            accesscontrollevel.toString() === "1" ?
                                                !userEditable ?
                                                    data = (
                                                        <button
                                                            className="max-h-fit w-full max-w-max cursor-pointer text-xl text-gray-600"
                                                            onClick={() => editUserAccess(cell.row.original)}
                                                            id="editButton">
                                                            <MdEdit onClick={() => editUserAccess(cell.row.original)}/>
                                                        </button>
                                                    ) :
                                                    data = (
                                                        <button
                                                            className="max-h-fit w-full max-w-max cursor-pointer text-xl text-gray-600 grid grid-cols-2 gap-2 items-center"
                                                            id="editButton">
                                                            <MdOutlineSave className="text-green-800 "
                                                                           onClick={() => saveUserAccess(cell.row.original)}/>
                                                            <MdOutlineCancel className="text-red-800"
                                                                             onClick={editingCancel}/>
                                                        </button>
                                                    ) :
                                                <button
                                                    className="max-h-fit w-full max-w-max cursor-pointer text-xl text-gray-600 grid grid-cols-2 gap-2 items-center"
                                                    id="editButton">
                                                    <MdPeople className="text-green-800 "/>
                                                </button>
                                        }

                                    }
                                    return (
                                        <td
                                            {...cell.getCellProps()}
                                            key={index}
                                            className="pt-[14px] pb-[16px] sm:text-[14px]"
                                        >
                                            {data}
                                        </td>
                                    );
                                })}
                            </tr>
                        );
                    })}
                    </tbody>
                </table>
            </div>
            {/* pagination */}
            <div className=" mt-2 flex h-20 w-full items-center justify-between px-6">
                {/* left side */}
                <div className=" flex items-center gap-3">
                    <p className="> Show rows per page text-sm text-gray-700 font-bold dark:text-white">
                        Show rows per page{" "}
                    </p>
                    <select
                        value={pageSize}
                        onChange={(e) => setPageSize(Number(e.target.value))}
                        className="h-[32px] w-[75px] rounded-[20px] border border-gray-700 px-2 text-gray-700 font-bold dark:!border-white/10 dark:bg-navy-800 dark:text-white"
                        name=""
                        id=""
                    >
                        <option value="10">10</option>
                        <option value="20">20</option>
                        <option value="30">30</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </select>
                </div>
                <div className="flex items-center gap-4">
                    <p className="text-sm font-bold text-gray-700 dark:text-white">
                        Page {currentPage + 1} of {totalPages}
                    </p>
                </div>
                {/* right side */}
                <div className="flex items-center gap-3">
                    {state.pageIndex !== 0 && (
                        <button
                            onClick={previousPage}
                            disabled={state.pageIndex === 0}
                            className={`linear flex items-center justify-center rounded-full bg-[#004c86] p-2 text-lg text-white transition duration-200 hover:bg-[#004c86] active:bg-[#004c86] dark:bg-[#004c86] dark:text-white dark:hover:bg-[#004c86] dark:active:bg-[#004c86] `}
                        >
                            <MdChevronLeft/>
                        </button>
                    )}
                    <p className="text-sm text-gray-700 font-bold dark:text-white ">
                        {currentPage + 1}
                    </p>
                    {state.pageIndex !== totalPages - 1 && (
                        <button
                            onClick={nextPage}
                            disabled={state.pageIndex === totalPages}
                            className={`linear flex items-center justify-center rounded-full bg-[#004c86] p-2 text-lg text-white transition duration-200 hover:bg-[#004c86] active:bg-[#004c86] dark:bg-[#004c86] dark:text-white dark:hover:bg-[#004c86] dark:active:bg-[#004c86] `}
                        >
                            <MdChevronRight/>
                        </button>
                    )}
                </div>
            </div>
        </div>
    )
        ;
}

export default UsersOverView;

